import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox } from '@material-ui/core';

export const CheckboxOption = ({
  checked,
  label,
  onChange,
  option,
  onKeyDown
}) => {
  const checkbox = useMemo(
    () => <Checkbox checked={checked} color="primary" />,
    [checked]
  );

  const handleClick = useCallback(
    event => {
      event.stopPropagation();
      event.preventDefault();
      onChange(option, event);
    },
    [onChange, option]
  );

  const handleKeyDown = useCallback(
    event => {
      if (onKeyDown) {
        onKeyDown(event);
      }
    },
    [onKeyDown]
  );

  return (
    <FormControlLabel
      control={checkbox}
      label={label}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    />
  );
};

CheckboxOption.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
  onKeyDown: PropTypes.func
};

export default CheckboxOption;
